import { ReactElement, useState } from 'react';
import Select from 'react-select';
import tools from '../../../../utils/tools';

const Prices = ({ form, setForm, stores, brands, cars }) => {

  const list = () => {
    const rows: ReactElement[] = []

    form?.variations?.map((variant, index) => {
      rows.push(
        <div className={`AddInfoContainer ${index % 2 == 0 ? 'backgroundGrey' : ''}`} key={index}>
          <label>قیمت خرید</label>
          <input className="persianName" defaultValue={variant.buyPrice} onChange={(input) => setForm((prev) => {
              const cp = prev.variations;

              cp[index].buyPrice = input.target.value;

              return { ...prev, variations: cp };
          })}/>
          <label>قیمت فروش</label>
          <input className="persianName" defaultValue={variant.sellPrice} onChange={(input) => setForm((prev) => {
            const cp = prev.variations;

            cp[index].sellPrice = input.target.value;

            return { ...prev, variations: cp };
          })}/>
          {/* <label>ماشین</label> */}
          {/* <Select options={tools.selectFormatter(cars, 'id', 'slug', 'انتخاب کنید')} value={tools.selectFormatter(cars.filter(e => e.id == variant.carId), 'id', 'slug')} className="width100" */}
          {/*         onChange={(selected) => setForm((prev) => { */}
          {/*           const cp = prev.variations; */}

          {/*           cp[index].carId = selected.value; */}

          {/*           return { ...prev, variations: cp }; */}
          {/*         })} */}
          {/* /> */}
          <label>برند</label>
          <Select options={tools.selectFormatter(brands, 'id', 'title', 'انتخاب کنید')} value={tools.selectFormatter(brands.filter(e => e.id == variant.brandId), 'id', 'title')} className="width100"
                  onChange={(selected) => setForm((prev) => {
                    const cp = prev.variations;

                    cp[index].brandId = selected.value;

                    return { ...prev, variations: cp };
                  })}
          />
          <label>فروشگاه</label>
          <Select options={tools.selectFormatter(stores, 'id', 'title', 'فروشگاه جدید')} value={{ value: variant?.storeId, label: stores.find(e => e.id == variant.storeId)?.title }} className="width100" id="infoTitle" onChange={(selected: any) => setForm((prev) => {
            const cp = prev.variations;

            cp[index].storeId = selected.value;

            return { ...prev, variations: cp };
          })}/>
          {!variant?.storeId &&
              <>
          <span className="blueText billHeader">
            فروشگاه جدید
          </span>
                  <label>عنوان فروشکاه</label>
                  <input className="persianName" value={form?.newStore?.title} onChange={(input) => setForm(prev => ({...prev, newStore: { ...prev.newStore, title: input.target.value }}))} />
                  <label >شماره تلفن</label>
                  <input className="persianName" value={form?.newStore?.phoneNumber} onChange={(input) => setForm(prev => ({...prev, newStore: { ...prev.newStore, phoneNumber: input.target.value }}))} />
                  <label>آدرس</label>
                  <textarea className="persianName" onChange={(input) => setForm(prev => ({...prev, newStore: { ...prev.newStore, address: input.target.value }}))} >{form?.newStore?.address}</textarea>
              </>
          }
        </div>
      )
    })
    return rows
  };
  return (
    <>
      {list()}
      <span className="addProductButton" onClick={() => setForm(prev => {
        const cp = prev?.variations || [];

        cp[cp.length] = {
          buyPrice: 0,
          sellPrice: 0,
          storeId: '',
          brandId: '',
          // carId: form?.carId,
          productId: form?.productId
        }

        return {
          ...prev,
          variations: cp
        };
      })}>اضافه کردن مورد دیگر
      </span>
    </>
  );

};

export default Prices;
